{
  "title": "Welcome Back",
  "subtitle": {
    "email": "Sign in to your account",
    "password": "Enter your password",
    "magicLink": "We'll send you a login link",
    "setupPassword": "Set up your password"
  },
  "buttons": {
    "loginMicrosoft": "Login with Microsoft",
    "loginMagicLink": "Login with Magic Link",
    "usePassword": "Use password instead (for special cases only)",
    "login": "Login",
    "changeEmail": "Change email",
    "forgotPassword": "Forgot password?",
    "setupPassword": "Set Up Password",
    "sendLoginLink": "Send login link"
  },
  "fields": {
    "email": "Email",
    "password": "Password"
  },
  "errors": {
    "enterEmail": "Please enter your email address",
    "enterPassword": "Please enter your password",
    "invalidCredentials": "Invalid email or password",
    "notWhitelisted": "Password authentication is not available for your account. Please use Microsoft or Google to sign in.",
    "genericError": "An error occurred. Please try again."
  },
  "messages": {
    "passwordRestricted": "Password authentication is restricted per your organization's policy. Most users should use Microsoft or Google login above.",
    "setupRequired": "Your account is approved for password authentication. Please set up a password to continue.",
    "noPasswordSet": "No password set for this account. You can log in using a magic link sent to your email, or contact your administrator to set up password authentication.",
    "magicLinkTooltip": "Magic Link Login allows user to securely login without a password. A link will be sent to the email address associated with your account."
  },
  "magicLinkPage": {
    "title": "Login with a Magic Link",
    "description": "Enter your email address below to receive a magic link to login.",
    "emailLabel": "Email",
    "sendButton": "Send",
    "successTitle": "Check your email",
    "successMessage": "An email with subject <u>Login to AirPlx</u> has been sent to <u>{{email}}</u> with a magic link has been sent to your email address. Click the link to login."
  }
}
